import { useEffect, useRef } from 'react';
import { useStore } from '../store/useStore.js';

export function InlineLabelEditor() {
  const id = useStore((s) => s.editingLabelId);
  const nodes = useStore((s) => s.nodes);
  const cam = useStore((s) => s.cam);
  const updateNode = useStore((s) => s.updateNode);
  const setEditingLabelId = useStore((s) => s.setEditingLabelId);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (id) {
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      }, 20);
    }
  }, [id]);

  if (!id) return null;
  const node = nodes.find((n) => n.id === id);
  if (!node) return null;

  // Screen position of label (below node blob).
  const canvasW = window.innerWidth;
  const canvasH = window.innerHeight - 54;
  const sx = (node.x + cam.x) * cam.zoom + canvasW / 2;
  const sy = (node.y + cam.y) * cam.zoom + canvasH / 2 + 54;
  const labelY = sy + (node.size || 22) * cam.zoom + 10;
  const fontSize = Math.max(11, Math.min(16, 12 * cam.zoom));

  function save(val: string) {
    const trimmed = val.trim();
    if (trimmed && trimmed !== node!.label) updateNode(id!, { label: trimmed });
    setEditingLabelId(null);
  }

  return (
    <input
      ref={inputRef}
      defaultValue={node.label}
      onBlur={(e) => save(e.target.value)}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') { e.preventDefault(); save(e.currentTarget.value); }
        if (e.key === 'Escape') { e.preventDefault(); setEditingLabelId(null); }
      }}
      style={{
        position: 'fixed',
        left: sx,
        top: labelY,
        transform: 'translateX(-50%)',
        minWidth: Math.max(80, node.label.length * fontSize * 0.65),
        maxWidth: 220,
        background: 'rgba(2, 6, 20, 0.92)',
        border: `1px solid ${node.color}`,
        borderRadius: 6,
        color: 'var(--text)',
        fontSize,
        padding: '3px 10px',
        outline: 'none',
        zIndex: 250,
        textAlign: 'center',
        fontFamily: 'Outfit, ui-sans-serif',
        boxShadow: `0 0 12px rgba(0,0,0,0.5)`,
      }}
    />
  );
}
